// TODO - disassemble
const BOARD = {
  NO_ITEM: '등록된 글이 없습니다.',
  RETRY_LATER: '잠시 후 다시 시도해주세요.'
};

export {
  BOARD
};


// WEBPACK FOOTER //
// ./_src/js/model/msg/board.js